export const projects = [
  {
    name: "Erika Casals",
    description: "Sitio web para inmobiliaria en Madrid, enfocada en ayudar a comprar o vender la propiedad ideal.",
    placeholder: "/assets/vids/erikacasals.mp4",
    url: "https://www.erikacasals.com/",
    code: "",
    technologies: "React, Styled Components, React Router, Framer Motion, Contentful, Vercel"
  },
  {
    name: "Unit Dreams",
    description: "Sitio web de una agencia musical 360 dedicada a la gestión artística, producción discográfica y organización de conciertos para artistas del género urbano.",
    placeholder: "/assets/vids/unitdreams.mp4",
    url: "https://www.unitdreams.com/",
    code: "",
    technologies: "React, Next.js, Turbopack, Supabase, PostgreSQL, Tailwind CSS, GSAP, Shopify, PWA, Vercel"
  },
  {
    name: "Spectrum FEL",
    description: "Portal administrativo para los documentos tributarios de la corporación, así como el envío de correos individualmente y de forma masiva.",
    placeholder: "/assets/img/spectrum.gif",
    url: "https://spectrum.feel.com.gt/",
    code: "",
    technologies: "Ruby on Rails, HTML, CSS, JavaScript"
  },
  {
    name: "FigueVel",
    description: "Sitio web estático para restaurante y/o cafetería.",
    placeholder: "/assets/vids/figuevel.mp4",
    url: "https://figuevel.netlify.app/",
    code: "https://github.com/ZarakiLancelot/figuevel",
    technologies: "HTML, CSS, JavaScript, Netlify"
  },
  {
    name: "Blog de Café",
    description: "Sitio web estático sobre un Blog de Café.",
    placeholder: "/assets/vids/blogcafe.mp4",
    url: "https://blog-cafe-einsen.netlify.app/",
    code: "",
    technologies: "HTML, CSS, JavaScript"
  },
  {
    name: "Bienes Raíces",
    description: "Sitio web estático para venta y compra de Bienes Raíces.",
    placeholder: "/assets/vids/bienesraices.mp4",
    url: "https://bienes-raices-einsen.netlify.app/",
    code: "https://github.com/ZarakiLancelot/bienes-raices-einsen",
    technologies: "HTML, CSS, JavaScript"
  },
  {
    name: "Popochos",
    description: "Sitio web estático para emprendimiento de Repostería.",
    placeholder: "/assets/vids/popochos.mp4",
    url: "https://popochos.shop",
    code: "https://github.com/ZarakiLancelot/popochos",
    technologies: "HTML, CSS, JavaScript"
  },
  {
    name: "Blog - DevChapin",
    description: "Blog personal para compartir conocimiento sobre diferentes tecnologías, pero principalmente de Ruby.",
    placeholder: "/assets/vids/devchapin.mp4",
    url: "https://developer-chapin.com",
    code: "https://github.com/ZarakiLancelot/blog",
    technologies: "Ruby, HTML, CSS, JavaScript, Bridgetown"
  }
];
